module.exports = __webpack_public_path__ + "static/about-one-small-842b061d3d535c5aa8ae9bc94361328c.jpg";